/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUnitPriceCheapestSkuRequest {
    getFixupPrototypeFunction() { return ResourceUnitPriceCheapestSkuRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceUnitPriceCheapestSkuRequest>): ResourceUnitPriceCheapestSkuRequest {
        let obj = Object.assign(new ResourceUnitPriceCheapestSkuRequest(), model);
        ResourceUnitPriceCheapestSkuRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUnitPriceCheapestSkuRequest>): ResourceUnitPriceCheapestSkuRequest {
        if (!model) return null;
        return ResourceUnitPriceCheapestSkuRequest.newInstance(<ResourceUnitPriceCheapestSkuRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUnitPriceCheapestSkuRequest) {
        if (!obj) return;

        models.ResourceUnitPriceCheapestSkuRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUnitPriceCheapestSkuRequest): boolean {
        Object.setPrototypeOf(obj, ResourceUnitPriceCheapestSkuRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the service account
     */
    service_account_id: string;

    /**
     * Id of the resource
     */
    resource_id: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
